
<mat-nav-list class="navigation-list min-width-250">
  <app-menu-list-item *ngFor="let item of items$ | async" [item]="item"></app-menu-list-item>
</mat-nav-list>
